<template>
  <div class="wrap_address">
    <div>
      <h4 class="title-color">Security Questions</h4>
    </div>
    <div class="e-card-separator"></div>
    <div>
      <div>
        <div class="form-row">
          <div
            class="form-row-input"
            style="
              font-size: 10px;
              font-weight: 500;
              color: red;
              font-style: italic;
            "
          >
            <div>
              ** Note: You must configure your Security Questions while creating
              your account. These questions and answers are important as they
              will be used to identify you should you need to contact us for
              help.
            </div>
            <div style="padding-top: 5px">
              It is also important to keep your email address up to date as it
              is the only way a new password will be communicated.**
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input">
          <ejs-dropdownlist
            float-label-type="Always"
            id="ddlSecurityQuestionOne"
            ref="ddlSecurityQuestionOne"
            v-model="ddlSecurityQuestionOne"
            :change="dataBindOnQuestionOne"
            :fields="fields"
            :dataSource="dataSource"
            placeholder="Security Question1"
          ></ejs-dropdownlist>
          <span v-show="isddlSecurityQuestionOne" class="e-error"
            >This field is required</span
          >
          <span v-show="isddlSecurityQuestionOneUnique" class="e-error"
            >Every selected questions should unique.</span
          >
        </div>
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="securityAnswerOne"
            @validate="(v) => (this.isSecurityAnswerOne = v)"
          >
            <input-password
              ref="refSecurityAnswerOne"
              v-model="securityAnswerOne"
              placeholder="Security Answer"
            />
          </scc-input-validator>
        </div>
      </div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input"></div>
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="confirmAnswerOne"
            @validate="(v) => (this.isConfirmAnswerOne = v)"
          >
            <input-password
              ref="refConfirmAnswerOne"
              v-model="confirmAnswerOne"
              placeholder="Confirm Answer"
            />
          </scc-input-validator>

          <span v-show="showConfirmAnswerOne" class="e-error"
            >Answer does not match</span
          >
        </div>
      </div>
    </div>
    <div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input">
          <ejs-dropdownlist
            float-label-type="Always"
            id="ddlSecurityQuestionTwo"
            ref="ddlSecurityQuestionTwo"
            v-model="ddlSecurityQuestionTwo"
            :change="dataBindOnQuestionTwo"
            :dataSource="dataSource"
            :fields="fields"
            placeholder="Security Question2"
          ></ejs-dropdownlist>
          <span v-show="isddlSecurityQuestionTwo" class="e-error"
            >This field is required</span
          >
          <span v-show="isddlSecurityQuestionTwoUnique" class="e-error"
            >Every selected questions should unique.</span
          >
        </div>
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="securityAnswerTwo"
            @validate="(v) => (this.isSecurityAnswerTwo = v)"
          >
            <input-password
              ref="refSecurityAnswerTwo"
              v-model="securityAnswerTwo"
              placeholder="Security Answer2"
            />
          </scc-input-validator>
        </div>
      </div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input"></div>
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="confirmAnswerTwo"
            @validate="(v) => (this.isConfirmAnswerTwo = v)"
          >
            <input-password
              ref="refConfirmAnswerTwo"
              v-model="confirmAnswerTwo"
              placeholder="Confirm Answer2"
            />
          </scc-input-validator>
          <span v-show="showConfirmAnswerTwo" class="e-error"
            >Answer does not match</span
          >
        </div>
      </div>
    </div>
    <div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input">
          <ejs-dropdownlist
            float-label-type="Always"
            id="ddlSecurityQuestionThree"
            ref="ddlSecurityQuestionThree"
            :change="dataBindOnQuestionThree"
            :dataSource="dataSource"
            v-model="ddlSecurityQuestionThree"
            :fields="fields"
            placeholder="Security Question3"
          ></ejs-dropdownlist>
          <span v-show="isddlSecurityQuestionThree" class="e-error"
            >This field is required</span
          >
          <span v-show="isddlSecurityQuestionThreeUnique" class="e-error"
            >Every selected questions should unique.</span
          >
        </div>
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="securityAnswerThree"
            @validate="(v) => (this.isSecurityAnswerThree = v)"
          >
            <input-password
              ref="refSecurityAnswerThree"
              v-model="securityAnswerThree"
              placeholder="Security Answer3"
            />
          </scc-input-validator>
        </div>
      </div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input"></div>
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator
            :rules="[requiredRule]"
            :value="confirmAnswerThree"
            @validate="(v) => (this.isConfirmAnswerThree = v)"
          >
            <input-password
              ref="refConfirmAnswerThree"
              v-model="confirmAnswerThree"
              placeholder="Confirm Answer3"
            />
          </scc-input-validator>
          <span v-show="showConfirmAnswerThree" class="e-error"
            >Answer does not match</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';
import inputPassword from '../../../components/base/input-password.vue';

import {
  SECURITY_QUESTIONS,
  USER_SECURITY_QUESTIONS,
  UPDATE_USER_SECURITY_QUESTIONS,
} from '../store';
import { USER_SECURITY_QUESTIONS_ANSWER } from '../../auth/store';

Vue.use(DropDownListPlugin);
Vue.use(TextBoxPlugin);

export default {
  name: 'SecurityQuestions',
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  components: {
    SccInputValidator,
    inputPassword,
  },
  mounted() {
    this.getSecurityQuestions().then(() => {
      if (this.$store.getters.loggedUser !== null) this.getUserSequrityQuestions();
    });
  },
  data() {
    return {
      username: null,
      userId: null,
      showPassword: false,
      passwordType: 'password',
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      securityAnswerOne: null,
      confirmAnswerOne: null,
      dataSource: [],
      fields: { text: 'question', value: 'id' },
      ddlSecurityQuestionOne: null,
      ddlSecurityQuestionTwo: null,
      ddlSecurityQuestionThree: null,
      securityAnswerTwo: null,
      confirmAnswerTwo: null,
      securityAnswerThree: null,
      confirmAnswerThree: null,
      idUserSecurityQuestionOne: null,
      idUserSecurityQuestionTwo: null,
      idUserSecurityQuestionThree: null,
      isConfirmAnswerOne: false,
      showConfirmAnswerOne: false,
      isConfirmAnswerTwo: false,
      showConfirmAnswerTwo: false,
      isConfirmAnswerThree: false,
      showConfirmAnswerThree: false,
      isSecurityAnswerThree: false,
      isSecurityAnswerTwo: false,
      isSecurityAnswerOne: false,
      isddlSecurityQuestionOne: false,
      isddlSecurityQuestionTwo: false,
      isddlSecurityQuestionThree: false,
      isddlSecurityQuestionTwoUnique: false,
      isddlSecurityQuestionThreeUnique: false,
      isddlSecurityQuestionOneUnique: false,
    };
  },
  watch: {
    ddlSecurityQuestionOne(val) {
      const questionTwo = this.$refs.ddlSecurityQuestionTwo.ej2Instances.value;
      const questionThree = this.$refs.ddlSecurityQuestionThree.ej2Instances.value;

      if (val === null) this.isddlSecurityQuestionOne = true;
      else if (val !== null && (val === questionTwo || val === questionThree)) {
        this.isddlSecurityQuestionOneUnique = true;
      } else {
        this.isddlSecurityQuestionOneUnique = false;
        this.isddlSecurityQuestionOne = false;
      }
    },
    ddlSecurityQuestionTwo(val) {
      const questionOne = this.$refs.ddlSecurityQuestionOne.ej2Instances.value;
      const questionThree = this.$refs.ddlSecurityQuestionThree.ej2Instances.value;

      if (val === null) this.isddlSecurityQuestionTwo = true;
      else if (val !== null && (val === questionOne || val === questionThree)) {
        this.isddlSecurityQuestionTwoUnique = true;
      } else {
        this.isddlSecurityQuestionTwoUnique = false;
        this.isddlSecurityQuestionTwo = false;
      }
    },
    ddlSecurityQuestionThree(val) {
      const questionOne = this.$refs.ddlSecurityQuestionOne.ej2Instances.value;
      const questionTwo = this.$refs.ddlSecurityQuestionTwo.ej2Instances.value;

      if (val === null) this.isddlSecurityQuestionThree = true;
      else if (val !== null && (val === questionTwo || val === questionOne)) {
        this.isddlSecurityQuestionThreeUnique = true;
      } else {
        this.isddlSecurityQuestionThree = false;
        this.isddlSecurityQuestionThreeUnique = false;
      }
    },
    confirmAnswerOne(val) {
      if (
        val !== this.securityAnswerOne
        && (this.securityAnswerOne !== null || this.securityAnswerOne !== '')
      ) {
        this.isConfirmAnswerOne = false;
        this.showConfirmAnswerOne = true;
        this.isSecurityAnswerOne = false;
      } else {
        this.isConfirmAnswerOne = true;
        this.showConfirmAnswerOne = false;
        this.isSecurityAnswerOne = true;
      }
    },
    securityAnswerOne(val) {
      if (val !== this.confirmAnswerOne) {
        this.isConfirmAnswerOne = false;
        this.showConfirmAnswerOne = true;
        this.isSecurityAnswerOne = false;
      } else {
        this.isConfirmAnswerOne = true;
        this.showConfirmAnswerOne = false;
        this.isSecurityAnswerOne = true;
      }
    },
    confirmAnswerTwo(val) {
      if (
        val !== this.securityAnswerTwo
        && (this.securityAnswerTwo !== null || this.securityAnswerTwo !== '')
      ) {
        this.isConfirmAnswerTwo = false;
        this.showConfirmAnswerTwo = true;
        this.isSecurityAnswerTwo = false;
      } else {
        this.isConfirmAnswerTwo = true;
        this.showConfirmAnswerTwo = false;
        this.isSecurityAnswerTwo = true;
      }
    },
    securityAnswerTwo(val) {
      if (val !== this.confirmAnswerTwo) {
        this.isConfirmAnswerTwo = false;
        this.showConfirmAnswerTwo = true;
        this.isSecurityAnswerTwo = false;
      } else {
        this.isConfirmAnswerTwo = true;
        this.showConfirmAnswerTwo = false;
        this.isSecurityAnswerTwo = true;
      }
    },
    confirmAnswerThree(val) {
      if (
        val !== this.securityAnswerThree
        && (this.securityAnswerThree !== null || this.securityAnswerThree !== '')
      ) {
        this.isConfirmAnswerThree = false;
        this.showConfirmAnswerThree = true;
        this.isSecurityAnswerthree = false;
      } else {
        this.isConfirmAnswerThree = true;
        this.showConfirmAnswerThree = false;
        this.isSecurityAnswerthree = true;
      }
    },
  },
  securityAnswerThree(val) {
    if (val !== this.confirmAnswerThree) {
      this.isConfirmAnswerThree = false;
      this.showConfirmAnswerThree = true;
      this.isSecurityAnswerthree = false;
    } else {
      this.isConfirmAnswerThree = true;
      this.showConfirmAnswerThree = false;
      this.isSecurityAnswerthree = true;
    }
  },
  methods: {
    async getSecurityQuestions() {
      try {
        await this.$store.dispatch(SECURITY_QUESTIONS);
        if (this.$store.getters.securityQuestions) {
          this.dataSource = this.$store.getters.securityQuestions;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getUserSequrityQuestions() {
      try {
        this.userId = this.userProfileId; // this.$store.getters.loggedUser.email;
        if (this.userId !== null && this.userId !== '') {
          const { userId } = this;
          await this.$store.dispatch(USER_SECURITY_QUESTIONS_ANSWER, {
            userId,
          });
          const data = this.$store.getters.userserSecurityQuestionsAnswer;
          data.forEach((item) => {
            if (item.answerOrderId === 1) {
              this.ddlSecurityQuestionOne = item.securityQuestionId;
              this.securityAnswerOne = item.answer;
              this.confirmAnswerOne = item.answer;
              this.idUserSecurityQuestionOne = item.id;
            } else if (item.answerOrderId === 2) {
              this.ddlSecurityQuestionTwo = item.securityQuestionId;
              this.securityAnswerTwo = item.answer;
              this.confirmAnswerTwo = item.answer;
              this.idUserSecurityQuestionTwo = item.id;
            } else if (item.answerOrderId === 3) {
              this.ddlSecurityQuestionThree = item.securityQuestionId;
              this.securityAnswerThree = item.answer;
              this.confirmAnswerThree = item.answer;
              this.idUserSecurityQuestionThree = item.id;
            }
          });
        }
      } catch (err) {
        console.error('getUserSequrityQuestions ERROR', err);
      }
    },
    validateSecurityQuestions() {
      this.securityAnswerOne = this.securityAnswerOne === null ? '' : this.securityAnswerOne;
      this.securityAnswerTwo = this.securityAnswerTwo === null ? '' : this.securityAnswerTwo;
      this.securityAnswerThree = this.securityAnswerThree === null ? '' : this.securityAnswerThree;
      this.confirmAnswerOne = this.confirmAnswerOne === null ? '' : this.confirmAnswerOne;
      this.confirmAnswerTwo = this.confirmAnswerTwo === null ? '' : this.confirmAnswerTwo;
      this.confirmAnswerThree = this.confirmAnswerThree === null ? '' : this.confirmAnswerThree;
      this.isddlSecurityQuestionOne = this.ddlSecurityQuestionOne === null ? 1 : 0;
      this.isddlSecurityQuestionTwo = this.ddlSecurityQuestionTwo === null ? 1 : 0;
      this.isddlSecurityQuestionThree = this.ddlSecurityQuestionThree === null ? 1 : 0;
    },
    async securityQuestions() {
      try {
        const data = [];
        // if (this.$store.getters.confirmedUser !== null) {
        //   this.userId = this.$store.getters.confirmedUser.userId;
        // } else this.userId = this.$store.getters.loggedUser.id;

        this.userId = this.userProfileId;
        if (
          this.$refs.ddlSecurityQuestionOne.ej2Instances.value !== 0
          && this.securityAnswerOne !== ''
        ) {
          const elementOne = {};
          const currentQuestion = this.$refs.ddlSecurityQuestionOne.ej2Instances.value;
          const previousId = this.$refs.ddlSecurityQuestionOne.ej2Instances
            .previousItemData
            ? this.$refs.ddlSecurityQuestionOne.ej2Instances.previousItemData.id
            : currentQuestion;
          if (
            this.idUserSecurityQuestionOne !== null
            && previousId === currentQuestion
          ) {
            elementOne.id = this.idUserSecurityQuestionOne;
          }
          elementOne.userId = this.userId;
          elementOne.securityQuestionId = this.$refs.ddlSecurityQuestionOne.ej2Instances.value;
          elementOne.answer = this.securityAnswerOne;
          elementOne.answerOrderId = 1;
          data.push(elementOne);
        }
        if (
          this.$refs.ddlSecurityQuestionTwo.ej2Instances.value !== 0
          && this.securityAnswerTwo !== ''
        ) {
          const elementTwo = {};
          const currentQuestion = this.$refs.ddlSecurityQuestionTwo.ej2Instances.value;
          const previousId = this.$refs.ddlSecurityQuestionTwo.ej2Instances
            .previousItemData
            ? this.$refs.ddlSecurityQuestionTwo.ej2Instances.previousItemData.id
            : currentQuestion;
          if (
            this.idUserSecurityQuestionTwo !== null
            && previousId === currentQuestion
          ) {
            elementTwo.id = this.idUserSecurityQuestionTwo;
          }
          elementTwo.userId = this.userId;
          elementTwo.securityQuestionId = this.$refs.ddlSecurityQuestionTwo.ej2Instances.value;
          elementTwo.answer = this.securityAnswerTwo;
          elementTwo.answerOrderId = 2;
          data.push(elementTwo);
        }
        if (
          this.$refs.ddlSecurityQuestionThree.ej2Instances.value !== 0
          && this.securityAnswerThree !== ''
        ) {
          const elementThree = {};
          const currentQuestin = this.$refs.ddlSecurityQuestionThree.ej2Instances.value;
          const previousId = this.$refs.ddlSecurityQuestionThree.ej2Instances
            .previousItemData
            ? this.$refs.ddlSecurityQuestionThree.ej2Instances.previousItemData
              .id
            : currentQuestin;
          if (
            this.idUserSecurityQuestionThree !== null
            && previousId === currentQuestin
          ) {
            elementThree.id = this.idUserSecurityQuestionThree;
          }
          elementThree.userId = this.userId;
          elementThree.securityQuestionId = this.$refs.ddlSecurityQuestionThree.ej2Instances.value;
          elementThree.answer = this.securityAnswerThree;
          elementThree.answerOrderId = 3;
          data.push(elementThree);
        }
        if (
          this.idUserSecurityQuestionOne !== null
          && this.idUserSecurityQuestionTwo !== null
          && this.idUserSecurityQuestionThree !== null
        ) {
          await this.$store.dispatch(UPDATE_USER_SECURITY_QUESTIONS, { data });
        } else await this.$store.dispatch(USER_SECURITY_QUESTIONS, { data });
      } catch (err) {
        console.error(err);
      }
    },
    dataBindOnQuestionOne() {
      const { index, previousItemData } = this.$refs.ddlSecurityQuestionOne.ej2Instances;
      if (previousItemData !== null) {
        const listofItemsQ2 = this.$refs.ddlSecurityQuestionTwo.getItems();
        const listofItemsQ3 = this.$refs.ddlSecurityQuestionThree.getItems();

        for (let i = 0; i <= listofItemsQ2.length; i += 1) {
          const element = listofItemsQ2[i];
          const ele = listofItemsQ3[i];
          if (element.id === previousItemData.id) {
            element.hidden = false;
            ele.hidden = false;
            break;
          }
        }
        this.securityAnswerOne = null;
        this.confirmAnswerOne = null;
      }
      this.$refs.ddlSecurityQuestionTwo.getItems()[index].hidden = true;
      this.$refs.ddlSecurityQuestionThree.getItems()[index].hidden = true;
    },
    dataBindOnQuestionTwo() {
      const { index, previousItemData } = this.$refs.ddlSecurityQuestionTwo.ej2Instances;
      if (previousItemData !== null) {
        const listofItemsQ1 = this.$refs.ddlSecurityQuestionOne.getItems();
        const listofItemsQ3 = this.$refs.ddlSecurityQuestionThree.getItems();

        for (let i = 0; i <= listofItemsQ1.length; i += 1) {
          const element = listofItemsQ1[i];
          const ele = listofItemsQ3[i];
          if (element.id === previousItemData.id) {
            element.hidden = false;
            ele.hidden = false;
            break;
          }
        }
        this.securityAnswerTwo = null;
        this.confirmAnswerTwo = null;
      }
      this.$refs.ddlSecurityQuestionOne.getItems()[index].hidden = true;
      this.$refs.ddlSecurityQuestionThree.getItems()[index].hidden = true;
    },
    dataBindOnQuestionThree() {
      const { index, previousItemData } = this.$refs.ddlSecurityQuestionThree.ej2Instances;
      if (previousItemData !== null) {
        const listofItemsQ2 = this.$refs.ddlSecurityQuestionTwo.getItems();
        const listofItemsQ1 = this.$refs.ddlSecurityQuestionOne.getItems();

        for (let i = 0; i <= listofItemsQ2.length; i += 1) {
          const element = listofItemsQ2[i];
          const ele = listofItemsQ1[i];
          if (element.id === previousItemData.id) {
            element.hidden = false;
            ele.hidden = false;
            break;
          }
        }
        this.securityAnswerThree = null;
        this.confirmAnswerThree = null;
      }
      this.$refs.ddlSecurityQuestionOne.getItems()[index].hidden = true;
      this.$refs.ddlSecurityQuestionTwo.getItems()[index].hidden = true;
    },
  },
};
</script>
